export const styles = {
  heading: {
    fontFamily: 'Inter',
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '146%',
    color: '#131F1E',
    marginBottom: '8px',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    '& button': {
      minWidth: '36px',
      width: '36px !important',
      height: '36px !important',
    },
  },
  label: {
    color: '#6E707A',
    fontSize: '14px',
    lineHeight: '146%',
    fontFamily: 'Inter',
  },
};
